var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeableServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 5.91L11.08 1.08C10.71 0.71 10.2 0.5 9.67 0.5H2.5C1.4 0.5 0.51 1.4 0.51 2.5L0.5 18.5C0.5 19.6 1.39 20.5 2.49 20.5H14.5C15.6 20.5 16.5 19.6 16.5 18.5V7.33C16.5 6.8 16.29 6.29 15.91 5.91ZM10.5 11.5C11.05 11.5 11.5 11.95 11.5 12.5V15.5C11.5 16.05 11.05 16.5 10.5 16.5H9.5C9.5 17.05 9.05 17.5 8.5 17.5C7.95 17.5 7.5 17.05 7.5 16.5H6.5C5.95 16.5 5.5 16.05 5.5 15.5C5.5 14.95 5.95 14.5 6.5 14.5H9.5V13.5H6.5C5.95 13.5 5.5 13.05 5.5 12.5V9.5C5.5 8.95 5.95 8.5 6.5 8.5H7.5C7.5 7.95 7.95 7.5 8.5 7.5C9.05 7.5 9.5 7.95 9.5 8.5H10.5C11.05 8.5 11.5 8.95 11.5 9.5C11.5 10.05 11.05 10.5 10.5 10.5H7.5V11.5H10.5ZM10.5 6.5C9.95 6.5 9.5 6.05 9.5 5.5V2L14 6.5H10.5Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeableServiceIcon);
export default __webpack_public_path__ + "static/media/ChargeableServiceIcon.cb544c5a50e3374610ac4bca8a30c31b.svg";
export { ForwardRef as ReactComponent };